import formName from 'constants/formName'
import { actions } from 'data'
import { notifyError } from 'data/App/sagas'
import { call, put, takeEvery } from 'redux-saga/effects'
import { getExtraKYC, submitExtraKYC } from 'services/api/user'
import { Response } from 'utils/fetchApi'

import { ExtraKYC } from './types'

// FIXME actions.form.change is triggered to change the loading state in the
// verify tier 2 form in upgrade modal
const getExtraKYCSaga = function* (action) {
  yield put(actions.form.change(formName.TIER_TWO, 'loading', true))
  const data: Response<ExtraKYC> = yield call(getExtraKYC, action.payload)
  yield put(actions.form.change(formName.TIER_TWO, 'loading', false))

  if (!data.ok) {
    yield call(notifyError, data.error.cause, 'KO_SIGNUP')
    return
  }
  if (Object.keys(data.response).length === 0 && data.response.constructor === Object) {
    yield put(actions.auth.extraKYCQuestions.set())
  } else {
    yield put(actions.auth.extraKYCQuestions.set(data.response))
  }
}

// FIXME actions.form.change is triggered to change the loading state in the
// verify tier 2 form in upgrade modal
const submitExtraKYCSaga = function* (action) {
  yield put(actions.form.change(formName.TIER_TWO, 'loading', true))
  const data = yield call(submitExtraKYC, action.payload)
  yield put(actions.form.change(formName.TIER_TWO, 'loading', false))

  if (!data.ok) {
    yield call(notifyError, data.error.cause, 'KO_SIGNUP')
    return
  }
  yield put(actions.auth.extraKYCQuestions.set())
}

export default function* termsAndConditionsSagas() {
  yield takeEvery(actions.auth.extraKYCQuestions.fetch.type, getExtraKYCSaga)
  yield takeEvery(actions.auth.extraKYCQuestions.submit.type, submitExtraKYCSaga)
}
